import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-task-v2-archived-banner',
    templateUrl: './task-v2-archived-banner.component.html',
    styleUrls: ['./task-v2-archived-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-archived-banner' },
    standalone: false,
})
export class TaskV2ArchivedBannerComponent {
    @Output() restoreTask = new EventEmitter<void>();
    @Input() isRestoreButtonAvailable = false;
    @Input() archivedLabelId = 'task.archived_description';

    protected onRestoreButtonClick(): void {
        this.restoreTask.emit();
    }
}
